import { render } from "./RolesEditorProjectsPolicies.vue?vue&type=template&id=a85d7c80&scoped=true"
import script from "./RolesEditorProjectsPolicies.vue?vue&type=script&lang=js"
export * from "./RolesEditorProjectsPolicies.vue?vue&type=script&lang=js"

import "./RolesEditorProjectsPolicies.vue?vue&type=style&index=0&id=a85d7c80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85d7c80"]])

export default __exports__